import { LOCATION_FOR_HIRING, VACANCY_POSITION_SLOT_WORKER_TYPE } from 'domain/shared/newVacancy/constants';
import { AUSTIN_OFFICE_ID, KRAKOW_OFFICE_ID, MINSK_OFFICE_ID } from 'domain/shared/employee';

export const VACANCY_POSITION_SLOT_OFFICE_HIRING_LOCATION: Record<number, string> = {
  [AUSTIN_OFFICE_ID]: LOCATION_FOR_HIRING.US_ANYWHERE,
  [KRAKOW_OFFICE_ID]: LOCATION_FOR_HIRING.PL_PL,
  [MINSK_OFFICE_ID]: LOCATION_FOR_HIRING.BY_BY,
};

export const VACANCY_POSITION_SLOT_STATUS = {
  OPEN: 'OPEN',
  FILLED: 'FILLED',
} as const;

export const VACANCY_POSITION_SLOT_PAGE_SIZE = 100;

export const VACANCY_POSITION_SLOT_WORKER_TYPE_LABELS: Dictionary<string> = {
  [VACANCY_POSITION_SLOT_WORKER_TYPE.STAFF]: 'Staff',
  [VACANCY_POSITION_SLOT_WORKER_TYPE.CONTRACTOR]: 'Contractor',
};

export const VACANCY_POSITION_SLOT_STAFF_CONTRACT_TYPES = ['EMPLOYMENT_CONTRACT'];
export const VACANCY_POSITION_SLOT_CONTRACTOR_CONTRACT_TYPES = ['B2B_CONTRACT', 'CONTRACT_FOR_SERVICES'];
